<template>
    <header v-if="title !== 'semHeader'">
        <div class="header">
            <transition name="fade">
                <a v-if="hasArrow" @click="$router.go(-1)" class="arrow-back">
                    <img src="./assets/img/arrow-back.svg" alt="refresh-image" />
                </a>
            </transition>
            <transition name="fade">
                <a v-if="hasMenu" @click="drawerVisible = true" class="btnMenu">
                    <img src="./assets/img/menu-white.svg" alt="refresh-image" />
                </a>
            </transition>
            <a id="logo" href="/carregamento">
                <img src="./assets/img/logo-minus.png" alt="logo-supermercado" />
            </a>
            <div class="menu">
                <strong>{{ title }}</strong>
            </div>
            <button id="btnRefresh" :class="{ 'refresh-none': hasNoRefresh }" type="button" @click="sincronizaDados">
                <img src="./assets/img/refresh.svg" alt="refresh-image" />
                <span id="attNumber" v-if="getNumerosSync > 0">{{ getNumerosSync }}</span>
            </button>
            <button
                v-if="Refresh"
                id="btnRefresh"
                type="button"
                @click="this.$router.push({ name: 'carregamento', query: { from: this.$route.name } })"
            >
                <img src="./assets/img/refresh-white.svg" alt="refresh-image" />
            </button>
        </div>
    </header>

    <transition name="slide" mode="out-in">
        <template v-if="drawerVisible">
            <div>
                <div class="left-drawer" :style="{ width: drawerVisible ? '23%' : '0' }">
                    <transition name="slide" mode="out-in">
                        <div class="container_modal_suporte" v-if="modalSuporte">
                            <div class="modal_suporte">
                                <h1 class="titulo_suporte">Deseja iniciar um contato com nosso suporte?</h1>
                                <div class="buttons_suporte">
                                    <div class="cancelar_suporte btn_suporte" @click="modalSuporte = false">
                                        <h1>Cancelar</h1>
                                    </div>
                                    <a
                                        @click="modalSuporte = false"
                                        target="_blank"
                                        class="btn_suporte"
                                        href="https://wa.me/5544997525279?text=Ol%C3%A1%2C%20preciso%20de%20ajuda%20no%20app%20valid."
                                    >
                                        Continuar
                                    </a>
                                </div>
                            </div>
                        </div></transition
                    >
                    <div class="containerMenuDrawer">
                        <a @click="drawerVisible = false">
                            <img src="./assets/img/close-white.svg" alt="refresh-image" />
                        </a>
                        <h1 class="title-menu">Menu</h1>
                    </div>
                    <router-link
                        @click="drawerVisible = false"
                        class="btnRouter"
                        :class="this.$route.name == 'pedidos.comercial' ? 'activeRoute' : 'inactiveRoute'"
                        :to="{ name: 'pedidos.comercial' }"
                    >
                        <img :src="getImg('pedidos.comercial', 'money-check')" alt="tela pedidos comercial" />
                        <h1 :class="this.$route.name == 'pedidos.comercial' ? 'activeText' : 'inactiveText'">
                            Rebaixas
                        </h1>
                    </router-link>
                    <!-- <router-link
                        @click="drawerVisible = false"
                        class="btnRouter"
                        :class="this.$route.name == 'historico.comercial' ? 'activeRoute' : 'inactiveRoute'"
                        :to="{ name: 'historico.comercial' }"
                    >
                        <img :src="getImg('historico.comercial', 'check-square')" alt="tela pedidos comercial" />
                        <h1 :class="this.$route.name == 'historico.comercial' ? 'activeText' : 'inactiveText'">
                            Histórico de Solicitações
                        </h1>
                    </router-link> -->
                    <!-- <router-link
                        @click="drawerVisible = false"
                        class="btnRouter"
                        :class="this.$route.name == 'pedidos.comercial.pesaveis' ? 'activeRoute' : 'inactiveRoute'"
                        :to="{ name: 'pedidos.comercial.pesaveis' }"
                    >
                        <img :src="getImg('pedidos.comercial.pesaveis', 'scale')" alt="tela pedidos comercial" />
                        <h1 :class="this.$route.name == 'pedidos.comercial.pesaveis' ? 'activeText' : 'inactiveText'">
                            Rebaixas - Pesáveis
                        </h1>
                    </router-link> -->
                    <div @click="modalSuporte = true" class="btnRouter inactiveRoute">
                        <img
                            style="width: 24px; height: 24px"
                            src="./assets/img/whatsapp-black.svg"
                            alt="tela pedidos comercial"
                        />
                        <h1 class="inactiveText">Suporte</h1>
                    </div>
                    <router-link @click="drawerVisible = false" class="btnSair" :to="{ name: 'login' }">
                        <h1>Sair</h1>
                    </router-link>
                </div>
            </div>
        </template>
    </transition>

    <template v-if="isLogin">
        <header-principal :hasNoRefresh="true" titulo="Login"></header-principal>
    </template>

    <ModalIdle v-if="isIdle && !isLogin" />

    <mensagem-alerta @closeModal="closeModal" :mensagem="mensagem"></mensagem-alerta>

    <router-view v-slot="slotProps" v-if="!sincronizing">
        <transition name="slide" mode="out-in">
            <component :is="slotProps.Component"></component>
        </transition>
    </router-view>

    <tela-sync v-if="sincronizing" @closePopUp="closePopUp" :msgSync="msgSync"></tela-sync>

    <template v-if="!isSave && !isLogin">
        <footer v-if="title !== 'semHeader'">
            <div class="footer-logo">
                <img src="./assets/img/logo-minus.png" alt="relogio" />
            </div>
        </footer>
    </template>

    <div class="btn-save" v-if="isLogin">
        <button class="salvar" type="submit" form="formLogin">Entrar</button>
    </div>
</template>

<script>
import HeaderPrincipal from './components/HeaderPrincipal';
import MensagemAlerta from './components/MensagemAlerta.vue';
import TelaSync from './components/TelaSync.vue';
import ModalIdle from './components/ModalIdle.vue';

export default {
    components: {
        MensagemAlerta,
        HeaderPrincipal,
        TelaSync,
        ModalIdle,
    },
    data() {
        return {
            title: 'Valid',
            drawerVisible: false,
            hasArrow: false,
            hasNoRefresh: false,
            isSave: false,
            mensagem: {},
            isLogin: false,
            sincronizing: false,
            counter: 0,
            msgSync: 'Sincronizando... Por favor, aguarde.',
            Refresh: false,
            hasMenu: false,
            modalSuporte: false,
        };
    },
    computed: {
        getNumerosSync() {
            return this.$store.getters.getNumerosSync;
        },

        isIdle() {
            return this.$store.state.idleVue.isIdle;
        },
    },
    methods: {
        getImg(tela, nomeImg) {
            let nomeTela = this.$route.name;
            let resp = '';
            if (nomeImg) resp = nomeImg;
            let isBlack = true;
            if (tela === nomeTela) isBlack = false;
            return resp === '' ? '' : require(`./assets/img/${resp}${isBlack ? '-black' : ''}.svg`);
        },

        sincronizaDados() {
            if (navigator.onLine) {
                this.sincronizing = true;

                setTimeout(() => {
                    this.sincronizing = false;

                    if (this.counter > 0) {
                        this.mensagem = {
                            isSend: true,
                            body: `${this.counter} sincronizações geraram erro. Certifique sua internet e sincronize novamente. `,
                            error: true,
                        };
                    } else {
                        this.mensagem = {
                            isSend: true,
                            body: 'Dados sincronizados com sucesso!',
                            error: false,
                        };
                    }

                    setTimeout(() => {
                        this.mensagem.isSend = false;
                        this.counter = 0;
                    }, 3000);
                }, 4000);
            } else {
                this.mensagem = {
                    isSend: true,
                    body: 'Você precisa estar conectado a internet.',
                    error: true,
                };
            }
        },

        closePopUp() {
            this.sincronizing = false;
        },

        closeModal() {
            this.mensagem.isSend = false;
        },
    },
    watch: {
        $route: function (val) {
            this.title = val.meta.title;
            this.hasArrow = val.meta.hasArrow;
            this.hasNoRefresh = val.meta.hasNoRefresh;
            this.Refresh = val.meta.Refresh;
            this.isSave = val.meta.isSave;
            this.isLogin = val.meta.isLogin;
            this.hasMenu = val.meta.hasMenu;
        },
    },
};
</script>

<style>
:root {
    --verde: #56bb8f;
    --vermelho: #ef6969;
    --branco: #ffffff;
    --preto: #000;
    --cinza: #cdcdcd;
    --cinza-escuro: #5f6368;
    --cinza-claro: #f4f4f4;
    --azul-escuro: #0f1628;
}

* {
    font-family: 'Karla', sans-serif;
    font-size: 18px;
    margin: 0;
    padding: 0;
    text-decoration: none;
    list-style: none;
    box-sizing: border-box;
    font-weight: 400;
}

body {
    width: 100%;
    min-height: 100%;
    scroll-behavior: smooth;
    overscroll-behavior-y: contain;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
    opacity: 1;
}

.fade-enter-active,
.fade-leave-active {
    transition: all 0.2s ease;
}

.slide-enter-from,
.slide-leave-to {
    transform: translateX(-100vw);
}

.slide-enter-to,
.slide-leave-from {
    transform: translateX(0px);
}

.slide-enter-active,
.slide-leave-active {
    transition: all 0.4s ease-in-out;
}

.slide-both-enter-from {
    transform: translateX(-100vw);
}

.slide-both-leave-to {
    transform: translateX(100vw);
}

.slide-both-enter-to,
.slide-both-leave-from {
    transform: translateX(0px);
}

.slide-both-enter-active,
.slide-both-leave-active {
    transition: all 0.4s ease-in-out;
}

header {
    width: 100%;
    display: flex;
    min-height: 56px;
    position: absolute;
    top: 0;
    background-color: #56bb8f;
    z-index: 2;
}

.header {
    width: 100%;
    align-items: center;
    padding: 5px 20px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid var(--cinza);
}

.header p {
    font-size: 16px;
}

.header button a {
    background-color: #fff;
}

#logo {
    /* display: flex; */
    display: none;
}

#logo img {
    width: 70px;
}

.menu strong {
    text-decoration: none;
    color: #fff;
    font-weight: bold;
    font-size: 1.5rem;
    text-align: center;
}

.header a img {
    width: 25px;
}

.header button {
    cursor: pointer;
    border: none;
}

.arrow-back {
    cursor: pointer;
    display: flex;
    align-items: center;
}

footer {
    width: 100%;
    position: fixed;
    bottom: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    background-color: var(--vermelho);
    box-shadow: 0 0 5px #cdcdcd;
}

.footer-logo {
    width: 100%;
    position: fixed;
    display: flex;
    bottom: 0;
    padding: 10px;
    background-color: #fff;
    box-shadow: 0 0 5px #a8a8a8;
    place-items: center;
    place-content: center;
}

footer div {
    display: flex;
}

footer img {
    width: 70px;
}

.format-footer {
    place-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 12px;
}

.format-footer h3 {
    font-size: 15px;
    margin-top: 5px;
    color: var(--branco);
    font-weight: 500;
}

#btnRefresh {
    background-color: transparent;
    display: flex;
}

#btnRefresh:hover {
    cursor: pointer;
}

#btnRefresh img {
    width: 35px;
}

#btnRefresh.refresh-none {
    display: none;
}

#attNumber {
    border-radius: 30%;
    position: absolute;
    bottom: 3px;
    font-size: 10px;
    right: 3px;
    background-color: #ef6969;
    color: #fff;
    padding: 3px;
}

.btn-save {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 0;
    background-color: #fff;
    width: 100%;
    box-shadow: 0 0 5px #cdcdcd;
    justify-content: flex-end;
}

.salvar {
    cursor: pointer;
    min-width: 64px;
    border: none;
    padding: 20px 45px;
    background-color: #fff;
    color: var(--verde);
    font-weight: 600;
    font-size: 20px;
}

.salvar:hover {
    box-shadow: none;
    background-color: var(--azul-escuro);
    color: #fff;
}

/* menu drawer */
.btnMenu {
    cursor: pointer;
}

.menu strong {
    text-decoration: none;
    color: #fff;
    font-weight: bold;
    font-size: 1.5rem;
    text-align: center;
}

.left-drawer {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    overflow: hidden;
    height: 100vh;
    border-right: 1px solid #cdcdcd;
    background: #fff;
    z-index: 200;
    transition: 1s ease-in-out;
}

.container_modal_suporte {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 300;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
}

.modal_suporte {
    width: 80%;
    height: 20%;
    background-color: #fff;
    margin-top: 20%;
    border-radius: 10px;
    padding: 15px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.titulo_suporte {
    font-weight: bold;
    font-size: 25px;
    text-align: center;
}

.buttons_suporte {
    display: flex;
    justify-content: space-around;
    width: 70%;
    margin-top: 5%;
}

.btn_suporte {
    padding: 10px 15px;
    border-radius: 10px;
    font-size: 18px;
    font-weight: bold;
    text-decoration: none;
    color: #fff;
    background-color: #56bb8f;
    cursor: pointer;
    transition: box-shadow 1s;
}

.cancelar_suporte {
    background-color: #ef6969;
}

.btn_suporte:hover {
    box-shadow: 2px 3px 2px rgba(0, 0, 0, 0.7);
}

.containerMenuDrawer {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 15%;
    width: 100%;
    padding: 10px 10px;
    /* box-shadow: 0 3px 2px #fff; */
    border-bottom: 1px solid #fff;
    background-color: #0f1628;
}

.containerMenuDrawer a {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.title-menu {
    font-weight: 700;
    color: #fff;
    font-size: 20px;
    text-align: center;
}

.activeRoute {
    background-color: #56b88f;
}

.inactiveRoute {
    background-color: #f1f1f1;
}

.activeText {
    color: #fff;
}

.inactiveText {
    color: #000;
}

.btnRouter {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid #fff;
    margin: 10px 20px;
    padding: 20px 15px;
    border-radius: 10px;
    transition: box-shadow 1s;
    cursor: pointer;
}

.btnRouter h1 {
    font-size: 20px;
    padding-left: 10px;
    text-align: left;
}

.btnRouter:hover {
    box-shadow: 0 3px 2px #1a905d;
}

.btnSair {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    background-color: #ef6969;
}

.btnSair h1 {
    color: #fff;
    font-size: 20px;
    font-weight: bold;
}
/* final menu drawer */

@media (max-width: 319px) {
    .header p {
        font-size: 14px;
    }

    #logo img {
        width: 50px;
    }

    .header a img {
        width: 22px;
    }

    #btnRefresh img {
        width: 22px;
    }
}

@media (max-width: 300px) {
    #logo {
        display: none;
    }
}
</style>
